/*******************************
 * If the wordpress included
 * jQuery is used, the following
 * must be set, to enable the
 * use of the $ var as jQuery.
 ******************************/

window.$ = jQuery
